module.exports = __webpack_public_path__ + "img/fishdom_solitaire.56d30b15.png";